module.exports = __webpack_public_path__ + "static/media/average-savings.8e368461.png";